/*eslint no-console: 0*/

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {FormattedMessage, defineMessages, injectIntl, FormattedDate} from 'react-intl';
import AppPanel from '../fw/AppPanel.react';
import types from "../../common/model-api/types";
import AppliedFlowDescription from './AppliedFlowDescription.react';
import ScenarioIcon, {SMALL_SIZE, DEFAULT_SIZE} from '../scenarios/ScenarioIcon.react';
import DetailBox from '../fw/DetailBox.react';
import urlMapping from '../app/URLMapping';
import DetailToolBar from '../fw/DetailToolBar.react';
import Link from 'react-router/lib/Link';
import DeleteButton from '../fw/DeleteButton.react';
import * as BrowserPermission from '../BrowserPermission';
import * as Permission from '../../common/util/Permission';
import LoadingButton from '../fw/LoadingButtonNew.react';
import LoadingButton2 from '../fw/LoadingButton.react';
import PlayPauseFlowMutation from './PlayPauseFlowMutation.react';
import BlockUnblockFlowMutation from './BlockUnblockFlowMutation.react';
import DebugFlowMutation from './DebugFlowMutation.react';
import {displayError, sendError} from '../app/errorDisplayer';
import mutationError from '../channel-defs/mutationError';
import InvokeFlowActionMutation from './InvokeFlowActionMutation.react';
import ConfirmDialog from '../fw/ConfirmDialog.react';
import GridList from '../fw/GridList.react';
import {FLOW_STEP_HOOK, FLOW_STEP_EVENT, FLOW_STEP_FORM, FLOW_STEP_INCOMING_MAIL} from '../../common/model-api/FlowStepDefType';
import {FLOW_OPTION_DEF_OPTIONS_KEY} from "../../common/model-api/FlowOptionDefType";
import {getLocale} from "../locales";
import ResizePureComponent from '../app/ResizePureComponent.react';
import filesaver from "filesaver.js";
import {getLastOrganisationId} from '../app/LastOrganisationId';
import config from '../../common/config';
import {BILLING_STATUS_DEVELOPER, BILLING_STATUS_BILLED, BILLING_STATUS_FREE} from '../../common/model-api/OrganisationType';
import {getFlowTitle} from './FlowConfig.react';
import moment from 'moment';

import './flowSimpleList.scss';
import './FlowView.scss';
import FlowIcon from '../scenarios/FlowIcon.react';
import { getStrategyForFlow } from './FlowSimpleList.react';

const messages = defineMessages({
	title: {id: 'flow.title', 'defaultMessage': 'My flow'},
	pauseButton: {id: 'flow.pauseButton', 'defaultMessage': 'Pause'},
	pauseDescription: {id: 'flow.pauseDescription2', 'defaultMessage': 'Do you want to stop flow from processing? Billing will not be stopped.'},
	playButton: {id: 'flow.playButton', 'defaultMessage': 'Enable'},
	playDescription: {id: 'flow.playDescription', 'defaultMessage': 'Do you want to re-enable flow and allow processing?'},
	blockButton: {id: 'flow.blockButton', 'defaultMessage': 'Block'},
	blockDescription: {id: 'flow.blockDescription2', 'defaultMessage': 'Do you want to block flow and stop processing? It will stop billing.'},
	unblockButton: {id: 'flow.unblockButton', 'defaultMessage': 'Unblock'},
	unblockDescription: {id: 'flow.unblockDescription', 'defaultMessage': 'Do you want to unblock flow and allow processing?'},
	enableDebugButton: {id: 'flow.enableDebugButton', 'defaultMessage': 'Enable Debug'},
	enableDebugDescription: {id: 'flow.enableDebugDescription2', 'defaultMessage': 'Do you want to enable debug of this flow for 4 hours?'},
	disableDebugButton: {id: 'flow.disableDebugButton', 'defaultMessage': 'Disabe Debug'},
	disableDebugDescription: {id: 'flow.disableDebugDescription', 'defaultMessage': 'Do you want to immediately disable debug of this flow?'},

	errorUnknown: {id: 'invokeFlowAction.errorUnknown', 'defaultMessage': 'Unknown error during action'},
	errorDescription: {id: 'invokeFlowAction.errorDescription', 'defaultMessage': 'Error during action: {errorMessage}'},
	deleteConfirmMessage: {id: 'flow.deleteConfirmMessage', defaultMessage: 'Do you really want to delete flow?'},
	billingTrial: {id: 'flow.trial', defaultMessage: 'Trial'},
	billingDeveloper: {id: 'flow.developer', defaultMessage: 'Developer'},
	billingFree: {id: 'flow.free', defaultMessage: 'Free'},
	billingBilled: {id: 'flow.billed', defaultMessage: 'Billed'},
	editButtonTitle: {id: 'flow.editFlow', defaultMessage: 'Go to Flow Definition'},
});

const FLOW_VIEW_SMALL_BREAKPOINT = 500;

export class FlowView extends ResizePureComponent {
	static propTypes = {
		intl: PropTypes.object,
		relay: PropTypes.object,
		user: PropTypes.object.isRequired,
	};

	static contextTypes = {
		router: PropTypes.object
	};

	typeName = 'flows';

	constructor(props) {
		super(props);

		document.body.classList.add('FlowViewBody');

		this.state = {
			small: false
		};
	}

	componentWillUnmount() {
		super.componentWillUnmount();

		document.body.classList.remove('FlowViewBody');
	}

	onResize() {
		let isSmall = window.innerWidth <= FLOW_VIEW_SMALL_BREAKPOINT;

		this.setState({
			small: isSmall
		});
	}


	activateFlow() {
		let path = urlMapping.getUrl(types['flows'], "create-step-4",  this.props.user.organisation.flow);
		this.context.router.push(path);
	}

	playPause(pause) {
		let {flow} = this.props.user.organisation;

		return new Promise((resolve, reject) => {
			this.props.relay.commitUpdate(
				new PlayPauseFlowMutation({
					flow_id: flow['realId'],
					organisation_id: this.props.user.organisation['realId'],
					pause: pause
				}), {onSuccess: resolve, onFailure: reject}
			);
		});
	}

	blockUnblock(pause) {
		let {flow} = this.props.user.organisation;

		return new Promise((resolve, reject) => {
			this.props.relay.commitUpdate(
				new BlockUnblockFlowMutation({
					flow_id: flow['realId'],
					organisation_id: this.props.user.organisation['realId'],
					pause: pause
				}), {onSuccess: resolve, onFailure: reject}
			);
		});
	}

	debug(debug) {
		let {flow} = this.props.user.organisation;

		return new Promise((resolve, reject) => {
			this.props.relay.commitUpdate(
				new DebugFlowMutation({
					flow_id: flow['realId'],
					organisation_id: this.props.user.organisation['realId'],
					debug: debug
				}), {onSuccess: resolve, onFailure: reject}
			);
		});
	}

	performAction(flowStepDef) {
		return new Promise((resolve, reject) => {
			let onSuccess = ({invokeFlowAction}) => {
				if (!invokeFlowAction.success) {
					let message = invokeFlowAction.message
						? this.props.intl.formatMessage(messages.errorDescription, {errorMessage: invokeFlowAction.message})
						: this.props.intl.formatMessage(messages.errorUnknown);

					let self = this;
					displayError(message).then(() => {
						self.setState({
							isSending: false
						});
					}).catch((e) => {
						sendError(e);
					});
				} else if (invokeFlowAction.flowInvocation) {
					let url = urlMapping.getUrl(types['flowInvocations'], 'view', invokeFlowAction.flowInvocation);
					this.context.router.push(url);
				} else if (invokeFlowAction.downloadContent) {
					let blob = new Blob([atob(invokeFlowAction.downloadContent)], {type: invokeFlowAction.downloadContentType || "application/json;charset=utf-8"});
					filesaver.saveAs(blob, invokeFlowAction.downloadFileName || 'dativery-export.txt', true);
				}
				resolve();
			};

			let onFailure = (transaction) => {
				let error = mutationError(transaction, false);
				displayError(error).catch((e) => {
					/* ignore error */
				});

				reject(error);
			};

			let args = {};

			let mutationArgs = {
				flow: this.props.user.organisation.flow,
				flowStepDef: flowStepDef,
				args: args,
			};

			try {
				if (this.props.relay) {
					this.props.relay.commitUpdate(
						new InvokeFlowActionMutation(mutationArgs), {onSuccess: onSuccess, onFailure: onFailure}
					);
				}
			} catch (error) {
				displayError(error).catch((e) => {
				/* ignore error */
				});

				reject(error);
			}
		});
	}

	onClickPause() {
		return new Promise((resolve, reject) => {
			let confirmDialogConfig  = {
				message: this.props.intl.formatMessage(messages.pauseDescription),
				confirm: this.props.intl.formatMessage(messages.pauseButton),
				confirmStyle: 'btn-danger'
			};

			return ConfirmDialog(this.props.intl, confirmDialogConfig).then(() => {
				return this.playPause(true).then(() => {
					return resolve();
				});
			}).catch(() => {
				resolve();
			});
		});
	}

	onClickPlay() {
		return new Promise((resolve, reject) => {
			let confirmDialogConfig  = {
				message: this.props.intl.formatMessage(messages.playDescription),
				confirm: this.props.intl.formatMessage(messages.playButton),
				confirmStyle: 'btn-danger'
			};

			return ConfirmDialog(this.props.intl, confirmDialogConfig).then(() => {
				return this.playPause(false).then(() => {
					return resolve();
				});
			}).catch(() => {
				resolve();
			});
		});
	}

	onClickBlock() {
		return new Promise((resolve, reject) => {
			let confirmDialogConfig  = {
				message: this.props.intl.formatMessage(messages.blockDescription),
				confirm: this.props.intl.formatMessage(messages.blockButton),
				confirmStyle: 'btn-danger'
			};

			return ConfirmDialog(this.props.intl, confirmDialogConfig).then(() => {
				return this.blockUnblock(true).then(() => {
					return resolve();
				});
			}).catch(() => {
				resolve();
			});
		});
	}

	onClickUnblock() {
		return new Promise((resolve, reject) => {
			let confirmDialogConfig  = {
				message: this.props.intl.formatMessage(messages.unblockDescription),
				confirm: this.props.intl.formatMessage(messages.unblockButton),
				confirmStyle: 'btn-danger'
			};

			return ConfirmDialog(this.props.intl, confirmDialogConfig).then(() => {
				return this.blockUnblock(false).then(() => {
					return resolve();
				});
			}).catch(() => {
				resolve();
			});
		});
	}

	onClickEnableDebug() {
		return new Promise((resolve, reject) => {
			let confirmDialogConfig  = {
				message: this.props.intl.formatMessage(messages.enableDebugDescription),
				confirm: this.props.intl.formatMessage(messages.enableDebugButton),
				confirmStyle: 'btn-danger'
			};

			return ConfirmDialog(this.props.intl, confirmDialogConfig).then(() => {
				return this.debug(true).then(() => {
					return resolve();
				});
			}).catch(() => {
				resolve();
			});
		});
	}

	onClickDisableDebug() {
		return new Promise((resolve, reject) => {
			let confirmDialogConfig  = {
				message: this.props.intl.formatMessage(messages.disableDebugDescription),
				confirm: this.props.intl.formatMessage(messages.disableDebugButton),
				confirmStyle: 'btn-danger'
			};

			return ConfirmDialog(this.props.intl, confirmDialogConfig).then(() => {
				return this.debug(false).then(() => {
					return resolve();
				});
			}).catch(() => {
				resolve();
			});
		});
	}

	getBreadcrum(flow, type) {
		return [
			{type: types['organisations'], data: this.props.user.organisation},
			{type: type, data: flow},
		];
	}

	static getBillingStatus(flow, intl) {
		const hasBilling = BrowserPermission.hasPermission(Permission.PERM_INSTANCE_BILLING) && BrowserPermission.developerModeEnabled();

		let billingType = null;
		let billingIcon = null;
		if (flow.billingStatus === BILLING_STATUS_DEVELOPER) {
			billingType = intl.formatMessage(messages.billingDeveloper);
			billingIcon = "bug";
		} else if (flow.billingStatus === BILLING_STATUS_FREE) {
			billingType = intl.formatMessage(messages.billingFree);
			billingIcon = "beer";
		} else if (flow.billingStatus === BILLING_STATUS_BILLED) {
			billingType = intl.formatMessage(messages.billingBilled);
			billingIcon = "dollar";
		} else {
			billingType = intl.formatMessage(messages.billingTrial);
			billingIcon = "question";
		}

		if (hasBilling) {
			return (
				<div style={{"float": "right"}}>
					<Link className={"btn btn-sm btn-inline"} style={{'height': '2.2em', 'padding': '5px 10px'}} to={urlMapping.getUrl('flows', "instance-view", flow)}>{billingType}<span className={"fa fa-fw fa-" + billingIcon}></span></Link>
				</div>
			);
		}

		return null;
	}

	static getStatusMessage(flow, intl) {

		let status = JSON.parse(flow.status || {});
		let style = {};

		if (status.status === 'warning') {
			style = {"color": "grey"};
		} else if (status.status === 'error') {
			style = {"color": "red"};
		}

		if (status.message) {
			return (<div style={style}>{status.icon ? <span className={status.icon} /> : null} {status.message}</div>);
		}

		return null;
	}

	getInvocationMessage(flow) {
		if (!flow.activated) {
			return (<div style={{"color": "red"}}>
				<FormattedMessage defaultMessage="Flow has not been activated yet." id="flow.notActivated"/> <div className="btn btn-primary" onClick={() => {this.activateFlow();}}><FormattedMessage defaultMessage="Activate flow" id="flow.activate"/></div>
			</div>);
		}

		return FlowView.getStatusMessage(flow, this.props.intl);
	}

	getHeader(flow, type) {
		let editButtonTitle = (<FormattedMessage defaultMessage="Add custom name" id="flow.addCustomName" />);
		if (flow.name) {
			editButtonTitle = (<FormattedMessage defaultMessage="Edit custom name" id="flow.editCustomName" />);
		}

		const isDeveloper = BrowserPermission.isDeveloper();
		const isPartner2 = BrowserPermission.isPartner2();
		const isPartner1 = BrowserPermission.isPartner1();

		let hasEditRights = BrowserPermission.hasOrganisationPermission(Permission.PERM_EDIT_CHANNEL, this.props.user.organisation.realId);

		if (flow.deleted) {
			hasEditRights = false;
		}

		let metadata = JSON.parse(flow.flowDef.metadata || '{}');

		let flowTitle = getFlowTitle(flow);

		let manualButtons = this.props.user.organisation.flow.manualButtons.edges.map(({node}) => node).filter((a) => a.flowStepDef ? true : false).sort((a, b) => {
			return (a.flowStepDef.name || '').localeCompare(b.flowStepDef.name);
		});

		return (
			<div className="flowView" data-description={flow.description} data-title={this.props.intl.formatMessage(messages.title)}>
				<DetailBox data={flow} metadata={type} urlMapping={urlMapping}>
					<div className="flex-row ChannelHeader">
						<div className="flex flex-row">
							<div className="flex-nogrow flex-column logoFlex">
							{isDeveloper ?
									//create button to edit flow definition
								<div className="flex-nogrow">
									<Link className='btn btn-default btn-inline' icon="fa fa-pencil" to={urlMapping.getUrl(types["flowDefs"], "view", flow.flowDef.realId)} type='button'>{this.props.intl.formatMessage(messages.editButtonTitle)}</Link>
								</div>
							: null}
								<span className="flex"></span>
								{flow.scenario ? <ScenarioIcon isFlow scenario={flow.scenario} size={this.state.small ? SMALL_SIZE : DEFAULT_SIZE} /> : <FlowIcon flow={flow} size={this.state.small ? SMALL_SIZE : DEFAULT_SIZE}  />}<span className="flex"></span>
							</div>
							<div className="flex flex-column middle">
								<span className="flex"></span>
								<h2>{flowTitle}</h2>
								{(flow.description ? <p>{flow.description}</p> : null)}
								<small>{this.getInvocationMessage(flow)}</small>
								<span className="flex"></span>
							</div>
							{flow.deleted ? null : <div className="flex-nogrow flex-column actions">
								<span className="flex flex1"></span>
								<DetailToolBar data={flow} editButtonTitle={editButtonTitle} metadata={type} organisationId={this.props.user.organisation.realId} urlMapping={urlMapping} vertical>
									{hasEditRights ? <Link className={"btn btn-default"} to={urlMapping.getUrl(type, "config", flow)}><i aria-hidden="true" className="fa fa-fw fa-cog"></i> <FormattedMessage defaultMessage="Configure" id="flow.config" /></Link> : null}

									{isDeveloper && hasEditRights ?
										[
											<Link className="btn btn-default" key='channelSelection' to={urlMapping.getUrl(type, "channel-config", flow)}><i aria-hidden="true" className="fa fa-fw fa-cog"></i> <FormattedMessage defaultMessage="Application Selection" id="flow.channelSelection" /></Link>,
											<Link className="btn btn-default" key='reactivateFlow btn last' onClick={() => { this.activateFlow(); }}><i aria-hidden="true" className="fa fa-fw fa-refresh"></i> <FormattedMessage defaultMessage="Reactivate Flow" id="flow.reactivateFlow" /></Link>,
										]
									: null}

									<div className="spacer" key="spacer1" />
									<Link className={"btn btn-default"} to={urlMapping.getUrl(types['flowInvocations'], "list", flow)}><i aria-hidden="true" className="fa fa-fw fa-list"></i> <FormattedMessage defaultMessage="Invocation history" id="flow.flowInvocations" /></Link>
									<Link className="btn btn-default" key='fetches' to={urlMapping.getUrl(types['fetches'], 'list-flow', flow)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="API Requests" id="fetches.list" /></Link>
									{metadata.hasIncomingEmail && flow.receivedAnyMails ? <Link className="btn btn-default" key='flowIncomingEmails' to={urlMapping.getUrl(types['flowIncomingEmails'], 'list', flow)}><i className="fa fa-fw fa-envelope"></i> <FormattedMessage defaultMessage="Incoming emails" id="flowIncomingEmails.list" /></Link> : null}
									<div className='spacer' key='spacer2'></div>
									{isPartner2 && hasEditRights ?
									<Link className={"btn btn-default"} key='logger' to={urlMapping.getUrl(types['flows'], 'logger', flow)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Logs" id="logger.list" /></Link> : null}
									{isPartner2 && hasEditRights ?
									<LoadingButton2 className={"btn " + (flow.debug === true ? "btn-info" : "btn-default")} key={(flow.debug === true ? "disableDebug" : "enableDebug")} onClick={() => { if (flow.debug === true) { return this.onClickDisableDebug(); } else { return this.onClickEnableDebug(); }}}>
												{flow.debug === true
													? <span><i aria-hidden="true" className="fa fa-fw fa-bug"></i> <FormattedMessage defaultMessage="Disable debug" id="flow.disableDebug" /></span>
													: <span><i aria-hidden="true" className="fa fa-fw fa-bug"></i> <FormattedMessage defaultMessage="Enable Debug" id="flow.enableDebug" /></span>
												}
									</LoadingButton2>
									: null}
									{isPartner1 && hasEditRights ?
									<Link className="btn btn-default" key='organisationEvents' to={urlMapping.getUrl(types['organisationEvents'], 'list-flow', flow)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Flow Events" id="organisationFlowEvents.list" /></Link>
									: null}
									{isPartner2 && hasEditRights ?
									<Link className="btn btn-default" key='flowHooks' to={urlMapping.getUrl(types['flows'], 'hooks', flow)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Flow Hooks" id="flowHooks.list" /></Link>
									: null}
									{isPartner1 && hasEditRights && flow.flowDef.flowCoordinationHooks.edges.length > 0 ?
									<Link className="btn btn-default" key='flowCoordinations' to={urlMapping.getUrl(types['flows'], 'coordinations', flow)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Flow coordination" id="coordinations.list" /></Link>
									: null}
									{isPartner1 ? <Link className="btn btn-default" key="fetchStats" to={urlMapping.getUrl(types['instances'], 'fetch-stats', {id: flow.instance_id}) + "?flow_id=" + flow.realId}><i className="fa fa-fw fa-line-chart"></i> <FormattedMessage defaultMessage="API statistics" id="InstanceView.fetchStats" /></Link> : null}
									<Link className="btn last btn-default" key="channelErrors" to={urlMapping.getUrl(types['channelErrors'], 'list-flow-fail', flow)}><i className="fa fa-fw fa-line-chart"></i> <FormattedMessage defaultMessage="Errors" id="channelErrors.flowList" /></Link>

									<div className='spacer' key='spacer3'></div>

									<LoadingButton2 className={"btn " + (flow.paused === true ? "btn-info" : "btn-default")} key={(flow.paused === true ? "reactivate" : "play")} onClick={() => { if (flow.paused === true) { return this.onClickPlay(); } else { return this.onClickPause(); }}}>
											{flow.paused === true
												? <span><i aria-hidden="true" className="fa fa-fw fa-play"></i> <FormattedMessage defaultMessage="Play" id="flow.play" /></span>
												: <span><i aria-hidden="true" className="fa fa-fw fa-pause"></i> <FormattedMessage defaultMessage="Pause" id="flow.reactivate" /></span>
											}
									</LoadingButton2>
									<DeleteButton
										className={"btn " + (isDeveloper && hasEditRights ? "" : "last")}
										confirmDialogConfig={{
											message: this.props.intl.formatMessage(messages.deleteConfirmMessage),
										}}
										data={flow}
										deleteFatQuery={Relay.QL `fragment on DeleteFlowPayload {
											updatedNode {
												id,
												deleted
											},
											organisation {
												flows(first: 100) {
													edges {
														node {
															id,
															deleted
														}
													}
												}
											}
										}`}
										deleteMutation={Relay.QL `mutation { deleteFlow }`}
										metadata={type}
										organisationId={this.props.user.organisation.realId}
										parent={this.props.user.organisation}
										redirectToList
										types={types}
										urlMapping={urlMapping}
									/>

									{(isPartner2 || flow.enabled === true) && hasEditRights ?
									<LoadingButton2 className={"btn last " + (flow.enabled === true ? "btn-default" : "btn-info")} key={(flow.enabled === true ? "reactivate2" : "play2")} onClick={() => { if (flow.enabled === true) { return this.onClickBlock(); } else { return this.onClickUnblock(); }}}>
									{flow.enabled === true
										? <span><i aria-hidden="true" className="fa fa-fw fa-ban"></i> <FormattedMessage defaultMessage="Block" id="flow.block" /></span>
										: <span><i aria-hidden="true" className="fa fa-fw fa-play"></i> <FormattedMessage defaultMessage="Unblock" id="flow.unblock" /></span>
									}
									</LoadingButton2>
									: null}


									{manualButtons.length > 0 ?
										[
											<div className="spacer" key="spacer2" />,
											manualButtons.map((node, idx) => {
												if (!node.flowStepDef) {
													return null;
												}

												/* all this is checked in FlowController, but we need to show/hode buttons for developer mode */
												let options = JSON.parse(node.flowStepDef.options || "{}");

												if (!hasEditRights && !options.regularUser) {
													return null;
												}

												if (options.developersOnly && !isDeveloper) {
													return null;
												}

												if (options.partner1Only && !isPartner1) {
													return null;
												}

												if (options.partner2Only && !isPartner2) {
													return null;
												}

												return (
													<LoadingButton
														className="btn btn-default"
														disabled={flow.paused || !flow.enabled || flow.flowDef.globallyDisabled || this.props.user.organisation.blocked}
														doneText={(<FormattedMessage defaultMessage="Done" id="flowView.done" />)}
														icon="fa-refresh"
														key={node.flowStepDef ? node.flowStepDef.realId : idx}
														onClick={() => this.performAction(node.flowStepDef)}
														progressText={(<FormattedMessage defaultMessage="Working" id="flowView.working" />)}
														text={node.flowStepDef ? node.flowStepDef.name : '?'}
														title={node.flowStepDef.description}
													/>
												);
											})
										]
									: null}

									{this.props.user.organisation.flow.manualForms.edges.length > 0 && hasEditRights ?
										[
											<div className="spacer" key="spacer2" />,
											this.props.user.organisation.flow.manualForms.edges.map(({node}, idx) => {
												if (!node.flowStepDef) {
													return null;
												}

												return (
													<a
														className="btn btn-default"
														disabled={flow.paused || !flow.enabled || flow.flowDef.globallyDisabled}
														href={"/api/v1/hooks/form/" + flow.realId + "/" + flow.secret + "/" + (node.flowStepDef.key ? node.flowStepDef.key : node.flowStepDef.realId) + "?html=true&lang=" + this.props.intl.locale + "&closeUrl=" + window.location.href}
														key={idx}
														title={node.flowStepDef.description}
													>
														<i className="fa fa-fw fa-file-text-o"></i> {node.flowStepDef && node.flowStepDef.name ? node.flowStepDef.name : <FormattedMessage defaultMessage="Fill in form" id="flowView.fillInForm" />}
													</a>
												);
											})
										]
									: null}
								</DetailToolBar>

								<span className="flex"></span>
							</div>}
						</div>
					</div>
					{flow.scenario ? <Link to={urlMapping.getUrl(types['scenarios'], 'view', flow.scenario)}><small><i aria-hidden="true" className="fa fa-info-circle" /> <FormattedMessage defaultMessage="More information about this integration" id="flow.scenarioDescription" /></small></Link> : null}
					{isDeveloper && hasEditRights && flow.flowDefVersion ? <p><small style={{color: '#bbb'}}><FormattedMessage defaultMessage="Version:" id="flow.flowDefVersion" /> <FormattedDate value={flow.flowDefVersion.createdAt}/>${flow.flowDefVersion.gitTag.substring(0, 3)}{getStrategyForFlow(this.props.organisation, flow)}</small></p> : <p><small style={{color: '#ff0000'}}>Dev version</small></p>}

				</DetailBox>
			</div>
		);
	}

	renderSettingsList(list, options) {
		return (
			<div>
				{list.map((writterOption, idx) => {
					let value = options[writterOption.id] !== void 0 ? options[writterOption.id] : writterOption.data.defaultValue;

					switch (writterOption.data.type) {
						case 'boolean':
							return (
								<div key={idx}><i className={"fa " + (value ? "fa-check" : "fa-times")}></i> {writterOption.data.name}</div>
							);
						case 'string': {
							if (value) {
								return (
									<div key={idx}>{writterOption.data.name}: <strong>{value}</strong></div>
								);
							} else {
								return null;
							}
						}
						case 'enum': {
							let enumValue = value;
							if (writterOption.data.enumValues) {
								Object.keys(writterOption.data.enumValues).map((enumKey) => {
									if (enumKey === value) {
										let enumItem = writterOption.data.enumValues[enumKey];
										if (enumItem.name && (typeof enumItem.name === "object" || typeof enumItem.name === 'function')) {
											let locale = getLocale();
											enumValue = enumItem.name[locale];
										} else {
											enumValue = enumItem.name;
										}
									}
								});
							}
							return (
								<div key={idx}>{writterOption.data.name}: <strong>{enumValue}</strong></div>
							);
						}
						case 'enums': {
							let enumValues = value || [];
							if (writterOption.data.enumValues) {
								enumValues = [];
								Object.keys(writterOption.data.enumValues).map((enumKey) => {
									if ((value || []).indexOf(enumKey) !== -1) {
										let enumItem = writterOption.data.enumValues[enumKey];
										if (enumItem.name && (typeof enumItem.name === "object" || typeof enumItem.name === 'function')) {
											let locale = getLocale();
											enumValues.push(enumItem.name[locale]);
										} else {
											enumValues.push(enumItem.name);
										}
									}
								});
							}
							if (!Array.isArray(enumValues)) {
								enumValues = [enumValues];
							}
							return (
								<div key={idx}>{writterOption.data.name}: <strong>{enumValues.join(", ")}</strong></div>
							);
						}
						default:
							return null;
					}
				}).filter(value => !!value)}
			</div>
		);
	}

	getSettings(flow) {
		const isDeveloper = BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) && BrowserPermission.developerModeEnabled();
		const isPartner2 = BrowserPermission.hasPermission(Permission.PERM_PARTNER2) || isDeveloper;
		const isPartner1 = BrowserPermission.hasPermission(Permission.PERM_PARTNER1) || isDeveloper || isPartner2;

		if (!isDeveloper) {
			return null;
		}

		const confOptions = {...JSON.parse(flow.options)};

		let options = {};
		if (confOptions.stepConfig) {
			Object.keys(confOptions.stepConfig).map((key) => {
				let value = confOptions.stepConfig[key];
				Object.keys(value).map((optionKey) => {
					let optionValue = value[optionKey];
					options[key + "_" + optionKey] = optionValue;
				});
			});
		}

		let configOptions = this.props.user.organisation.flow.configOptions;
		if (configOptions) {
			configOptions = JSON.parse(configOptions);
		}

		let writterList = [];
		let devWritterList = [];
		let writterDuplicity = {};
		Object.values(configOptions).map((stepOptions) => {
			stepOptions.map((options) => {
				Object.keys(options.configOptions).map((key) => {
					let writerOption = options.configOptions[key];

					let configId = options.flowStepConfigDef_id ? options.flowStepConfigDef_id : FLOW_OPTION_DEF_OPTIONS_KEY;
					if (!writterDuplicity[configId + '_' + key]) {
						writterDuplicity[configId + '_' + key] = true;

						if (!writerOption.flowEditableOnly) {

							writterList.push({
								id: configId + '_' + key,
								data: writerOption
							});
						}
						else if (isDeveloper) {
							devWritterList.push({
								id: configId + '_' + key,
								data: writerOption
							});
						}
					}
				});
			});
		});

		return (
			<div className="flowSettings">
				<h3><FormattedMessage defaultMessage="Flow settings:" id="flow.flowSettings"/></h3>

				{this.renderSettingsList(writterList, options)}

				{isDeveloper
					? (<div>
						<br /><strong><FormattedMessage defaultMessage="Developer only settings:" id="flow.devSettings" /></strong><br />
						{this.renderSettingsList(devWritterList, options)}
					</div>)
					: null}
			</div>
		);
	}

	render() {
		const {flow} = this.props.user.organisation;
		const type = types[this.typeName];

		if (!this.debugUntil || this.debugUntil !== flow.debugUntil) {
			let debugUntil = moment(flow.debugUntil).diff(moment(), 'millis', true);
			if (debugUntil > 0) {
				this.debugUntilTimer = setTimeout(() => {
					this.props.relay.forceFetch();
				}, debugUntil);
			}
			this.debugUntil = flow.debugUntil;
		}

		return (
			<AppPanel breadcrumbParams={this.getBreadcrum(flow, type)} className="FlowViewApp" title={this.props.intl.formatMessage(messages.title) + ' - ' + type.getDefaultTitle(flow)}>
				<h3><FormattedMessage defaultMessage="Active flow" id="flow.activeFlow" /> {FlowView.getBillingStatus(flow, this.props.intl)}</h3>

				{this.getHeader(flow, type)}

				{this.getSettings(flow)}


				{flow.channels.edges.length > 0 ?
					<div className="flowChannelList">
						<h3><FormattedMessage defaultMessage="Connected applications used in this flow:" id="flow.connectedChannels"/></h3>

						<GridList
							asRow={false}
							bothTitles
							edges={flow.channels}
							iconProperty="channelDef.icon"
							metadata={types['channels']}
							pageInfo={flow.channels.pageInfo}
							relay={this.props.relay}
							sortByTitle
							tagsProperty="channelDef.state"
							titleProperty="name"
							titleProperty2="channelDef.name"
							urlMapping={urlMapping}
						/>
					</div>
				: null}

				{flow.flowDef.appliedDescription
					? <div className="flowDescription">
						<h3><FormattedMessage defaultMessage="Flow steps:" id="flow.flowSteps"/></h3>

						<AppliedFlowDescription flow={flow} user={this.props.user} />
					</div>
					: null
				}

				{BrowserPermission.hasOrganisationPermission(Permission.PERM_DEVELOPER, this.props.user.organisation) && BrowserPermission.developerModeEnabled()
					? flow.flowDef.allFlowStepDefs.edges.map(({node}) => node).filter((step) => step.type === FLOW_STEP_HOOK || step.type === FLOW_STEP_EVENT || step.type === FLOW_STEP_FORM || step.type === FLOW_STEP_INCOMING_MAIL).map((step) => {
						if (step.type === FLOW_STEP_HOOK) {
							let asyncHook = false;
							let preferProxy = false;
							if (step && step['options']) {
								let parsedOptions = JSON.parse(step['options']);
								asyncHook = parsedOptions && parsedOptions['runAsync'];
								preferProxy = parsedOptions && parsedOptions['preferProxy'] ? true : false;
							}

							if (preferProxy) {
								return (
									<div key={step.realId}><code>https://hook-proxy.dativery.com/{config.STAGE}/api/v1/hooks/flow/{flow.realId}/{flow.secret}/{step.key ? step.key : step.realId}/{asyncHook ? '?html&lang=' + this.props.intl.locale : ''}</code></div>
								);
							} else {
								return (
									<div key={step.realId}><code>https://{window.location.hostname}/api/v1/hooks/flow/{flow.realId}/{flow.secret}/{step.key ? step.key : step.realId}/{asyncHook ? '?html&lang=' + this.props.intl.locale : ''}</code></div>
								);
							}
						} else if (step.type === FLOW_STEP_FORM) {
							return (
								<div key={step.realId}><code>https://{window.location.hostname}/api/v1/hooks/form/{flow.realId}/{flow.secret}/{step.key ? step.key : step.realId}/?html=true&lang={this.props.intl.locale}</code></div>
							);

						} else if (step.type === FLOW_STEP_INCOMING_MAIL) {
							let id = step.flowStepConfigDef_id || step.realId;
							let options = JSON.parse(flow.options);

							let email = options && options[id] ? options[id].email : undefined;

							return (
								<div key={step.realId}><code>{email}</code></div>
							);

						} else {
							return (
								<div key={step.realId}><code>https://{window.location.hostname}/api/v1/hooks/event/{flow.organisation_id}/:channelId/:sourceDefId/:key/create-or-update/</code></div>
							);
						}
					})
					: null
				}
			</AppPanel>
		);
	}
}

export default Relay.createContainer(wrapNotFound(injectIntl(FlowView), (props) => {
	return props.user.organisation && props.user.organisation.flow;
}), {
	initialVariables: {
		organisationId: '',
		flowId: '',
	},
	prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

		return variables;
	},
	fragments: {
		user: () => Relay.QL`
			fragment on User {
				featureFlags,
				${AppliedFlowDescription.getFragment('user')}
				organisation(id: $organisationId) {
					id,
					realId,
					name,
					blocked,
					flow(id: $flowId) {
						id,
						realId,
						organisation_id,
						instance_id,
						name,
						groupName,
						description,
						${AppliedFlowDescription.getFragment('flow')}
						secret,
						status,
						activated,
						deleted,
						enabled,
						paused,
						invalid,
						debug,
						debugUntil,
						hasInvalidChannel,
						receivedAnyMails,
						lastInvocationAt,
						lastInvocationErrorAt,
						lastInvocationError,
						billingStatus,
						options,
						configOptions,
						selectedChannels,
						${FlowIcon.getFragment('flow')},
						versionStrategy,
						flowDefVersion {
							id,
							realId,
							strategy,
							gitTag,
							createdAt,
						},
						channels(first: 100) {
							edges {
								node {
									id,
									realId,
									name,
									invalid,
									organisation_id,
									channelDef_id,
									channelDef {
										id,
										realId,
										name,
										icon,
										state
									}
								}
							}
						},
						manualButtons(first: 100) {
							edges {
								node {
									id,
									realId,
									type,
									flowStepDef_id,
									flowStepDef {
										id,
										realId,
										options,
										name,
										description
									},
								}
							}
						},
						manualForms(first: 100) {
							edges {
								node {
									id,
									realId,
									type,
									flowStepDef_id,
									flowStepDef {
										id,
										realId,
										key,
										options,
										name,
										description
									},
								}
							}
						},
						flowDef {
							id,
							realId,
							name,
							title,
							metadata,
							versionConfig,
							appliedDescription,
							globallyDisabled,
							allFlowStepDefs(first: 100) {
								edges {
									node {
										id,
										realId,
										key,
										type,
										options,
										flowStepConfigDef_id,
									}
								}
							},
							flowCoordinationHooks(first: 1) {
								edges {
									node {
										id,
									}
								}
							}
						},
						scenario {
							id,
							name,
							title,
							urlFragment
							${ScenarioIcon.getFragment('scenario')},
						},
					}
				}
			}
		`,
	},
});
